<div class="flex flex-col items-center justify-center w-full h-screen ">
    <div class="flex animate-pulse">
        <picture>
            <source class="h-20" type="image/webp" [attr.defaultImage]="brand.logoBase + '.webp'"
                [attr.lazyLoad]="brand.logoBase + '.webp'" />
            <img class="h-20" [defaultImage]="brand.logoBase + '.png'"
                [lazyLoad]="brand.logoBase + '.png'" />
        </picture>
    </div>
</div>